var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 67,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 69,
    width: 175,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_2",
    height: 4.78601,
    width: 20.73955,
    fill: "#FF0000",
    y: 34.59701,
    x: 7.45298
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_3",
    height: 4.78601,
    width: 20.73955,
    fill: "#FF0000",
    y: 26.62052,
    x: 7.45298
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_4",
    height: 4.78601,
    width: 20.73955,
    fill: "#FF0000",
    y: 18.64403,
    x: 7.45298
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_5",
    points: "14.951091766357422,10.666975021362305 10.165651321411133,15.452980995178223 31.383575439453125,15.452980995178223 31.383575439453125,36.670902252197266 36.169586181640625,31.884897232055664 36.169586181640625,10.666975021362305 ",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    d: "m144.19859,22.26786c-1.28373,-0.96913 -3.24282,-1.66587 -5.1113,-1.66587c-4.9616,0 -7.66808,5.13832 -7.66808,9.98229c0,2.57253 0.59375,6.74059 4.85748,6.74059c0.63765,0 1.16273,-0.06754 1.69739,-0.22512l0.97476,-6.90605l5.4124,0l-1.13572,8.03615c-2.55115,1.03892 -4.76856,1.44357 -7.44915,1.44357c-6.11139,0 -9.82921,-3.08918 -9.82921,-9.03286c0,-6.24984 4.33408,-12.28525 12.84072,-12.28525c2.23373,0 4.11234,0.46599 6.07537,1.42556l-0.66466,2.48699z"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_7",
    points: "68.77002716064453,39.38301086425781 71.69937896728516,18.644025802612305 66.28697204589844,18.644025802612305 63.358192443847656,39.38301086425781 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_8",
    points: "61.217323303222656,20.87775993347168 61.533050537109375,18.644025802612305 49.467857360839844,18.644025802612305 46.53851318359375,39.38301086425781 58.60426330566406,39.38301086425781 58.91943359375,37.1492805480957 52.266639709472656,37.1492805480957 53.330322265625,29.61852264404297 59.50360870361328,29.61852264404297 59.785011291503906,27.623979568481445 53.61227798461914,27.623979568481445 54.56452560424805,20.87775993347168 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_9",
    points: "161.84671020507812,20.87775993347168 162.161865234375,18.644025802612305 150.09609985351562,18.644025802612305 147.1678924560547,39.38301086425781 159.2325439453125,39.38301086425781 159.5482635498047,37.1492805480957 152.8954620361328,37.1492805480957 153.95858764648438,29.61852264404297 160.1318817138672,29.61852264404297 160.41326904296875,27.623979568481445 154.23997497558594,27.623979568481445 155.1927947998047,20.87775993347168 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_10",
    points: "89.08128356933594,20.87775993347168 89.3964614868164,18.644025802612305 77.33182525634766,18.644025802612305 74.40304565429688,39.38301086425781 79.81487274169922,39.38301086425781 81.1948471069336,29.61852264404297 87.36758422851562,29.61852264404297 87.64897918701172,27.623979568481445 81.47623443603516,27.623979568481445 82.42906188964844,20.87775993347168 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_11",
    points: "105.56948852539062,20.87775993347168 105.8846435546875,18.644025802612305 93.81889343261719,18.644025802612305 90.89067840576172,39.38301086425781 96.3030776977539,39.38301086425781 97.68135833740234,29.61852264404297 103.85464477539062,29.61852264404297 104.13604736328125,27.623979568481445 97.96275329589844,27.623979568481445 98.91556549072266,20.87775993347168 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    d: "m118.03539,39.38301l5.10793,0l-4.34309,-20.74743l-3.73189,0l-11.73089,20.74743l2.94567,0l3.7544,-6.62072l6.59145,0l1.40642,6.62072zm-6.8661,-8.6147l3.66548,-6.4637l1.37209,6.4637l-5.03758,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_13",
    height: 72.58814,
    width: 186.652,
    fill: "none",
    y: -0.5,
    x: -8.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_15",
    d: "m47.28703,49.16101l1.24096,0l0,6.97359l-1.24096,0l0,-6.97359z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_16",
    d: "m50.67562,49.16101l1.89099,0l1.86172,4.88506l1.88142,-4.88506l1.87129,0l0,6.97359l-1.18243,0l0,-5.79172l-0.01914,0l-2.11836,5.79172l-0.8667,0l-2.1178,-5.79172l-0.0197,0l0,5.79172l-1.18187,0l0,-6.97359l0.00056,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_17",
    d: "m60.38608,49.16101l1.89099,0l1.86172,4.88506l1.88142,-4.88506l1.87129,0l0,6.97359l-1.18243,0l0,-5.79172l-0.01914,0l-2.11836,5.79172l-0.8667,0l-2.1178,-5.79172l-0.01914,0l0,5.79172l-1.18187,0l0,-6.97359z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_18",
    d: "m73.37763,48.98316c2.17633,-0.0394 3.71332,1.41881 3.71332,3.65423c0,2.17689 -1.53643,3.63453 -3.71332,3.67392c-2.14706,0 -3.68405,-1.45764 -3.68405,-3.63453c0,-2.23542 1.53699,-3.69362 3.68405,-3.69362zm0.01013,6.20594c1.44751,0 2.40313,-1.10364 2.40313,-2.59111c0,-1.38898 -0.95506,-2.49206 -2.40313,-2.49206c-1.4385,0 -2.39413,1.10308 -2.39413,2.49206c0,1.48747 0.95563,2.59111 2.39413,2.59111z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_19",
    d: "m78.86263,49.16101l2.7183,0c1.05411,0 2.13749,0.48232 2.13749,1.75311c0,0.78791 -0.49245,1.31019 -1.21113,1.52686l0,0.0197c0.87683,0.09849 1.50716,0.78791 1.50716,1.68444c0,1.51673 -1.32032,1.98948 -2.63951,1.98948l-2.51175,0l0,-6.97359l-0.00056,0zm1.24153,2.83649l1.13291,0c0.82731,0 1.24096,-0.35456 1.24096,-0.87683c0,-0.60106 -0.41365,-0.89653 -1.34902,-0.89653l-1.02429,0l0,1.77337l-0.00056,0zm0,3.07286l1.14247,0c0.64046,0 1.52686,-0.10749 1.52686,-1.02429c0,-0.72882 -0.47275,-0.98489 -1.47734,-0.98489l-1.192,0l0,2.00918z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_20",
    d: "m85.80583,49.16101l1.24096,0l0,6.97359l-1.24096,0l0,-6.97359z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_21",
    d: "m89.16459,49.16101l1.24096,0l0,5.85081l2.9648,0l0,1.12278l-4.20577,0l0,-6.97359z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_22",
    d: "m94.83699,49.16101l1.24096,0l0,6.97359l-1.24096,0l0,-6.97359z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_23",
    d: "m98.19631,49.16101l4.61942,0l0,1.12278l-3.37846,0l0,1.71371l3.20118,0l0,1.12278l-3.20118,0l0,1.89099l3.55574,0l0,1.12278l-4.7967,0l0,-6.97303z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_24",
    d: "m104.80465,49.16101l2.42339,0c1.33945,0 2.60011,0.43335 2.60011,1.99961c0,1.00459 -0.5808,1.74354 -1.61522,1.89099l1.85159,3.08299l-1.49703,0l-1.61522,-2.95467l-0.9061,0l0,2.95467l-1.24096,0l0,-6.97359l-0.00056,0zm2.20616,2.95467c0.69955,0 1.51673,-0.05909 1.51673,-0.96519c0,-0.82731 -0.76821,-0.9258 -1.40868,-0.9258l-1.07325,0l0,1.89099l0.96519,0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f76c5e9ce81284f287f2a3a14562c777.svg";
export { ForwardRef as ReactComponent };